import { useController } from 'react-hook-form';
import { ShippingCostField } from './ShippingCostField';

const ShippingCost = ({
  control,
  requiresShippingCost,
  errors,
  canEditTracking,
  orderSource,
}) => {
  const { field } = useController({
    name: 'finalShippingCost',
    control,
  });

  return (
    <div className="row d-flex align-items-center my-2">
      <div className="col-12 col-md-4">
        <p className="fw-bold mb-0">Custo de envio</p>

        {errors.finalShippingCost && (
          <p className="text-danger">Campo obrigatório</p>
        )}
      </div>
      <div className="col-12 col-md-8">
        <ShippingCostField
          disabled={!canEditTracking}
          field={field}
          orderSource={orderSource}
          requiresShippingCost={requiresShippingCost}
        />
      </div>
    </div>
  );
};

export default ShippingCost;
